import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

type FormContainerProps = {
  maxWidth?: string;
  margin?: string;
};

export const GreyBackground = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  height: "auto",
  backgroundColor: "#EAEAF1",
  borderRadius: "12px",
  flex: 2,
}));

export const FormContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "maxWidth" && prop !== "margin",
})<FormContainerProps>(({ maxWidth, margin }) => ({
  backgroundColor: "#fff",
  borderRadius: "12px",
  boxShadow: "3px 1px 8px 0px #52527A1F",
  padding: "16px",
  flex: 2,
  height: "100%",
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "column",
  overflowY: "auto",
  maxWidth: maxWidth || "unset",
  margin: margin || "unset",
}));

export const CustomerManagementContainer = styled(Box)(() => ({
  display: "flex",
  gap: "1rem",
  maxWidth: "1570px",
  minWidth: "1226px",
}));

export const TabPanelContainer = styled(Box)(() => ({
  display: "flex",
  width: "100%",
}));

export const ListHeader = styled(Typography)(() => ({
  color: "textSecondary",
  fontWeight: "500",
  textTransform: "uppercase",
  fontSize: "13px",
}));
